module.exports = __webpack_public_path__ + "img/logo.6ca8d054.png";